import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { GlobalAlert } from '../../../global/components/GlobalAlert';

export const ConfirmDeleteModal = ({
  show,
  onHide,
  deleteTarget,
  handleDelete,
  error,
  setError
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Body className="text-center pt-4">
        <FaExclamationTriangle className="text-danger mb-3" size={40} />
        <h5 className="fw-bold mb-3">Confirm Deletion</h5>
        <p className="text-muted mb-4">
          Are you sure you want to delete <strong>{deleteTarget.name}</strong>? 
          This action cannot be undone.
        </p>
        <GlobalAlert message={error} onClose={() => setError("")} />
        <div className="d-flex gap-2 justify-content-center">
          <Button variant="light" onClick={onHide}>Cancel</Button>
          <Button variant="danger" onClick={handleDelete}>Delete</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
